import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "firme-head" }
const _hoisted_2 = { class: "row-actions" }
const _hoisted_3 = { class: "firma-form" }
const _hoisted_4 = { class: "ff-row" }
const _hoisted_5 = { class: "ff-field ff-full" }
const _hoisted_6 = { class: "ff-row" }
const _hoisted_7 = { class: "ff-field" }
const _hoisted_8 = { class: "ff-field ff-small" }
const _hoisted_9 = { class: "ff-row" }
const _hoisted_10 = { class: "ff-field" }
const _hoisted_11 = { class: "ff-row" }
const _hoisted_12 = { class: "ff-field" }
const _hoisted_13 = { class: "ff-field" }
const _hoisted_14 = { class: "ff-row ff-checks" }
const _hoisted_15 = { class: "ff-row ff-checks" }
const _hoisted_16 = { class: "ff-preview" }
const _hoisted_17 = { class: "ff-actions" }
const _hoisted_18 = { class: "del-body" }
const _hoisted_19 = { class: "ff-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "fh-title" }, "Firme", -1)),
        _createVNode(_component_DxButton, {
          text: "Adaugă firmă",
          icon: "add",
          type: "default",
          "styling-mode": "contained",
          onClick: _ctx.openAdd
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_v_divider, { class: "my-3" }),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.companies,
        "key-expr": "ID",
        "show-borders": true,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        "column-auto-width": true,
        "allow-column-resizing": true,
        onRowPrepared: _ctx.onRowPrepared
      }, {
        stareCell: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["stare-badge", data.data.Active ? 'on' : 'off'])
          }, _toDisplayString(data.data.Active ? 'Activă' : 'Inactivă'), 3)
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_DxButton, {
              icon: "edit",
              "styling-mode": "text",
              onClick: ($event: any) => (_ctx.openEdit(data.data))
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              icon: "trash",
              "styling-mode": "text",
              type: "danger",
              onClick: ($event: any) => (_ctx.remove(data.data))
            }, null, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            placeholder: "Caută firmă..."
          }),
          _createVNode(_component_DxPaging, { "page-size": 10 }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": [10, 20, 50],
            "show-info": ""
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Name",
            caption: "Denumire"
          }),
          _createVNode(_component_DxColumn, {
            caption: "Server",
            "calculate-cell-value": r => _ctx.srvOf(r.Source)
          }, null, 8, ["calculate-cell-value"]),
          _createVNode(_component_DxColumn, {
            caption: "Bază de date",
            "calculate-cell-value": r => _ctx.dbOf(r.Source)
          }, null, 8, ["calculate-cell-value"]),
          _createVNode(_component_DxColumn, {
            "data-field": "Active",
            caption: "Stare",
            width: 120,
            alignment: "center",
            "cell-template": "stareCell"
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 110,
            "cell-template": "actions"
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowPrepared"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.popupVisible,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.popupVisible) = $event)),
        title: _ctx.isNew ? 'Adaugă firmă' : 'Editează firmă',
        width: 560,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "Denumire", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.Name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Name) = $event)),
                  placeholder: "Nume companie"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[16] || (_cache[16] = _createElementVNode("label", null, "Server", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.Server,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Server) = $event)),
                  placeholder: "46.224.3.219"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Port", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.Port,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Port) = $event)),
                  placeholder: "1433"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[18] || (_cache[18] = _createElementVNode("label", null, "Bază de date", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.Database,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Database) = $event)),
                  placeholder: "Initial Catalog"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Utilizator", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.User,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.User) = $event)),
                  placeholder: "User ID"
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, "Parolă", -1)),
                _createVNode(_component_DxTextBox, {
                  value: _ctx.form.Password,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Password) = $event)),
                  mode: "password",
                  placeholder: "Password"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_DxCheckBox, {
                value: _ctx.form.IntegratedSecurity,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.IntegratedSecurity) = $event)),
                text: "Integrated Security"
              }, null, 8, ["value"]),
              _createVNode(_component_DxCheckBox, {
                value: _ctx.form.Encrypt,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Encrypt) = $event)),
                text: "Encrypt"
              }, null, 8, ["value"]),
              _createVNode(_component_DxCheckBox, {
                value: _ctx.form.TrustServerCertificate,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.TrustServerCertificate) = $event)),
                text: "Trust Server Certificate"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_DxCheckBox, {
                value: _ctx.form.Active,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.Active) = $event)),
                text: "Firmă activă"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[21] || (_cache[21] = _createElementVNode("label", null, "Connection string", -1)),
              _createElementVNode("code", null, _toDisplayString(_ctx.buildSource()), 1)
            ]),
            (_ctx.testMsg)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["ff-test", _ctx.testOk ? 'ok' : 'err'])
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.testOk ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.testMsg), 1)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_DxButton, {
                text: "Testează conexiunea",
                icon: "link",
                "styling-mode": "outlined",
                disabled: _ctx.testing,
                onClick: _ctx.testConnection
              }, null, 8, ["disabled", "onClick"]),
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "default",
                "styling-mode": "contained",
                onClick: _ctx.save
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.popupVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]),
      _createVNode(_component_DxPopup, {
        visible: _ctx.deleteVisible,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.deleteVisible) = $event)),
        title: "Confirmare ștergere",
        width: 420,
        height: "auto",
        "drag-enabled": false,
        "wrapper-attr": { class: 'era-edit-popup' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, [
              _cache[23] || (_cache[23] = _createTextVNode("Sigur vrei să ștergi firma ", -1)),
              _createElementVNode("strong", null, "„" + _toDisplayString(_ctx.toDelete && _ctx.toDelete.Name) + "\"", 1),
              _cache[24] || (_cache[24] = _createTextVNode("?", -1))
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "del-warn" }, "Acțiunea nu poate fi anulată.", -1)),
            _createElementVNode("div", _hoisted_19, [
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "ff-spacer" }, null, -1)),
              _createVNode(_component_DxButton, {
                text: "Șterge",
                type: "danger",
                "styling-mode": "contained",
                onClick: _ctx.confirmDelete
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                "styling-mode": "outlined",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.deleteVisible = false))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}